import list from './list'

export default { list, options: { label: 'Squads' } }
